import styled from 'styled-components';
import { FlexCenter } from '../../../global/commonStyle';

interface Props {
  isProjectOverView?: boolean;
}

const LoadingImage = styled.div<Props>`
  ${FlexCenter}
  position: absolute;
  top: 50%;
  left: ${({ isProjectOverView }) => (isProjectOverView ? '50%' : '55%')};
  transform: translate(-50%, -50%);
`;
export { LoadingImage };
